// Override Settings
var bcSfFilterSettings = {
    general: {
        limit: 24,
        /* Optional */
        loadProductFirst: false,
        paginationType: 'infinite'
    }
};

// Declare Templates
var bcSfFilterTemplate = {
    'soldOutClass': 'sold-out',
    'saleClass': 'on-sale',
    'soldOutLabelHtml': '<div>' + bcSfFilterConfig.label.sold_out + '</div>',
    'saleLabelHtml': '<div>' + bcSfFilterConfig.label.sale + '</div>',
    'vendorHtml': '<div>{{itemVendorLabel}}</div>',

    // Grid Template
    'productGridItemHtml': '<div class="collection__product{{itemTaggedClass}}" {{itemGroupData}}>' +
                                '<div class="collection__product-image">' +
                                    '<a href="{{itemUrl}}">' +
                                        '{{itemThumbHtml}}' +
                                        '{{itemTag}}' +
                                    '</a>'+
                                    //'{{itemQuickView}}' +
                                    '{{itemOptions}}' +
                                '</div>' +
                                '<a href="{{itemUrl}}">' +
                                  '<h6 class="collection__product-title">{{itemTitle}}</h6>' +
                                  '{{itemPrice}}' +
  								  '<div id="yotpo-category-stars">' +
                                  	'<div class="yotpo bottomLine" data-product-id="{{ product.id }}" style="padding: 4px 0 0 0;"></div>' +
  								  '</div>' +
                                '</a>' +
                                //'{{itemSwatches}}' +
                            '</div>',
    // 'productGridItemHtml': '<div class="collection__product">' +
    // '<div class="{{soldOutClass}} {{saleClass}}">' +
    // '<a href="{{itemUrl}}" class="grid-link">' +
    // '<span class="grid-link__image grid-link__image--product">' +
    // '{{itemSaleLabel}}' +
    // '{{itemSoldOutLabel}}' +
    // '<span class="grid-link__image-centered"><img src="{{itemThumbUrl}}" alt="{{itemTitle}}" /></span>' +
    // '</span>' +
    // '<p class="grid-link__title">{{itemTitle}}</p>' +
    // '{{itemVendor}}' +
    // '{{itemPrice}}' +
    // '</a>' +
    // '</div>' +
    // '</div>',

    // Pagination Template
    'previousActiveHtml': '<li><a href="{{itemUrl}}">&larr;</a></li>',
    'previousDisabledHtml': '<li class="disabled"><span>&larr;</span></li>',
    'nextActiveHtml': '<li><a href="{{itemUrl}}">&rarr;</a></li>',
    'nextDisabledHtml': '<li class="disabled"><span>&rarr;</span></li>',
    'pageItemHtml': '<li><a href="{{itemUrl}}">{{itemTitle}}</a></li>',
    'pageItemSelectedHtml': '<li><span class="active">{{itemTitle}}</span></li>',
    'pageItemRemainHtml': '<li><span>{{itemTitle}}</span></li>',
    'paginateHtml': '<ul class="pagination-custom">{{previous}}{{pageItems}}{{next}}</ul>',
  
    // Sorting Template
    'sortingHtml': '<label class="d-none">' + bcSfFilterConfig.label.sorting + '</label><select class="form-control collection__toolbar-sorter">{{sortingItems}}</select>',
};

/************************** BUILD PRODUCT LIST **************************/

// Build Product Grid Item
BCSfFilter.prototype.buildProductGridItem = function(data, index) {
    /*** Prepare data ***/
    var images = data.images_info;
    data.price_min *= 100, data.price_max *= 100, data.compare_at_price_min *= 100, data.compare_at_price_max *= 100; // Displaying price base on the policy of Shopify, have to multiple by 100
    var soldOut = !data.available; // Check a product is out of stock
    var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
    var priceVaries = data.price_min != data.price_max; // Check a product has many prices
    // Get First Variant (selected_or_first_available_variant)
    var firstVariant = data['variants'][0];
    (data.tags.includes('bundle')) ? bundle = true : bundle = false;

    if (getParam('variant') !== null && getParam('variant') != '') {
        var paramVariant = data.variants.filter(function(e) { return e.id == getParam('variant'); });
        if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
    } else {
        for (var i = 0; i < data['variants'].length; i++) {
            if (data['variants'][i].available) {
                firstVariant = data['variants'][i];
                break;
            }
        }
    }
    /*** End Prepare data ***/

    var itemSwatchHandles = [];
    for (var i = 0; i < data['variants'].length; i++) {
        var optionColor = data['variants'][i]['option_color'];
        var tags = data['variants'][i]['tags'];

        if (optionColor) {
            // handleize https://gist.github.com/dlindenkreuz/a439ec4b939f0561d6d9
            var itemSwatchHandle = optionColor.toLowerCase().replace(/[^\w\u00C0-\u024f]+/g, "-").replace(/^-+|-+$/g, "");

            // if not in array push
            if (itemSwatchHandles.indexOf(itemSwatchHandle) === -1) {
                itemSwatchHandles.push(itemSwatchHandle);
            }
        }
    }

    var itemTags = [];
    var dataGroupTag;
    for (var i = 0; i < data['tags'].length; i++) {
        var tag = data['tags'][i];

        if (bcSfFilterConfig.custom.productTags.indexOf(tag) !== -1 && itemTags.indexOf(tag) === -1) {
            itemTags.push(tag.substring(1));
        }

        if (tag.indexOf('group:') !== -1) {
            dataGroupTag = tag;
        }
    }

    // Get Template
    var itemHtml = bcSfFilterTemplate.productGridItemHtml;
    itemHtml = itemHtml.replace(/{{itemGroupData}}/, dataGroupTag ? 'data-product_group_tag="' + dataGroupTag + '"' : '');

    /*var itemSwatchHtml = '';
    if (itemSwatchHandles.length) {
        itemSwatchHtml += '<ul class="collection_product_swatches collection__product-swatch-list swatch__list">';

        for (var i = 0; i < itemSwatchHandles.length; i++) {
            itemSwatchHtml += '<a href="{{itemUrl}}?color={{itemSwatch}}" class="swatch__link d-none d-lg-inline-block">' +
                '<li class="{{itemSwatch}} swatch__list-item swatch__list-item--{{itemSwatch}}"></li>' +
                '</a>';
            itemSwatchHtml = itemSwatchHtml.replace(/{{itemSwatch}}/g, itemSwatchHandles[i]);
        }

        itemSwatchHtml += '</ul>';
    }*/

    var itemTagHtml = '';
    var itemTaggedClass = '';
    if (itemTags.length) {
        itemTagHtml = '<div class="collection__product-tag"><span>' + itemTags[0] +'</span></div>';
        itemTaggedClass = ' tagged';
    }
    itemHtml = itemHtml.replace(/{{itemTag}}/g, itemTagHtml);
    itemHtml = itemHtml.replace(/{{itemTaggedClass}}/g, itemTaggedClass);
  
    var itemQuickViewHtml = '';
    if (bcSfFilterConfig.custom.hasQuickview) {
      itemQuickViewHtml = '<div class="collection__quickview-link" data-product-handle="' + data.handle + '">' + bcSfFilterConfig.label.quickview +'</div>';
    }
    //itemHtml = itemHtml.replace(/{{itemQuickView}}/g, itemQuickViewHtml);


    // Add Thumbnail
    var itemThumbHtml = '<div class="collection__product-inner-image-wrapper">' +
                            '<img src="{{itemThumbUrl}}" alt="{{itemTitle}}" class="collection__product-featured-image"/>' +
                            '<img src="" aria-hidden="true" class="collection__product-variant-image"/>' +
                        '</div>';

    if (images.length > 0) {
        var itemFeaturedThumbUrl = this.optimizeImage(images[0]['src']);

        if (images.length > 1) {
            itemThumbHtml = '<div class="collection__product-inner-image-wrapper">' +
                                '<img src="{{itemThumbUrl}}" alt="{{itemTitle}}" class="collection__product-featured-image" />' +
                                '<img src="' + this.optimizeImage(images[1]['src']) + '" alt="{{itemTitle}}" class="collection__product-hover-image" />' +
                                '<img src="" aria-hidden="true" class="collection__product-variant-image"/>' +
                            '</div>';
            itemThumbHtml = itemThumbHtml.replace(/{{itemThumbUrl}}/g, itemFeaturedThumbUrl);
        } else {
            itemThumbHtml = itemThumbHtml.replace(/{{itemThumbUrl}}/g, itemFeaturedThumbUrl);
        }
    } else {
        itemThumbHtml = itemThumbHtml.replace(/{{itemThumbUrl}}/g, bcSfFilterConfig.general.no_image_url);
    }

    itemHtml = itemHtml.replace(/{{itemThumbHtml}}/g, itemThumbHtml);

    // Add Price
    var itemPriceHtml = '';
    if (data.title != '')  {
        var itemPriceWrapperClasses = 'collection__product-price-wrapper';
        var itemPriceClasses = 'collection__product-price';

        itemPriceHtml += '<p class="{{itemPriceWrapperClasses}}">';

        if (onSale) {
            itemPriceWrapperClasses += ' collection__product-price-wrapper--on-sale';
            itemPriceClasses += ' collection__product-price--sale-price';

            itemPriceHtml += '<span class="collection__product-price collection__product-price--original-price">' + this.formatMoney(data.compare_at_price_min) +'</span>';
        }

        itemPriceHtml += '<span class="{{itemPriceClasses}}">' + this.formatMoney(data.price_min) + '</span>';
        // if (onSale) {
        //     itemPriceHtml += '<s class="grid-link__sale_price">' + this.formatMoney(data.compare_at_price_min) + '</s> ';
        // }
        // if (priceVaries) {
        //     itemPriceHtml += (bcSfFilterConfig.label.from_price).replace(/{{ price }}/g, this.formatMoney(data.price_min));
        // } else {
        //     itemPriceHtml += this.formatMoney(data.price_min);
        // }
        itemPriceHtml += '</p>';

        itemPriceHtml = itemPriceHtml.replace(/{{itemPriceWrapperClasses}}/g, itemPriceWrapperClasses);
        itemPriceHtml = itemPriceHtml.replace(/{{itemPriceClasses}}/g, itemPriceClasses);
    }

    itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);

    // Add soldOut class
    var soldOutClass = soldOut ? bcSfFilterTemplate.soldOutClass : '';
    itemHtml = itemHtml.replace(/{{soldOutClass}}/g, soldOutClass);
  
    // Add onSale class
    var saleClass = onSale ? bcSfFilterTemplate.saleClass : '';
    itemHtml = itemHtml.replace(/{{saleClass}}/g, saleClass);
  
    // Add soldOut Label
    var itemSoldOutLabelHtml = soldOut ? bcSfFilterTemplate.soldOutLabelHtml : '';
    itemHtml = itemHtml.replace(/{{itemSoldOutLabel}}/g, itemSoldOutLabelHtml);

    // Add onSale Label
    var itemSaleLabelHtml = onSale ? bcSfFilterTemplate.saleLabelHtml : '';
    itemHtml = itemHtml.replace(/{{itemSaleLabel}}/g, itemSaleLabelHtml);

    // Add Vendor
    var itemVendorHtml = bcSfFilterConfig.custom.vendor_enable ? bcSfFilterTemplate.vendorHtml.replace(/{{itemVendorLabel}}/g, data.vendor) : '';
    itemHtml = itemHtml.replace(/{{itemVendor}}/g, itemVendorHtml);    

    // Add Quickshop
    let sizes = data.options_with_values.find(o => o.name == 'size');
    let firstAvailableVariant = data.variants.find(v => v.available === true);

    if(bundle) {
        qsHtml = `
            <div class="product__item-quickshop">
              <a href="{{itemUrl}}" class="button btn btn-primary btn-wide product__btn-cta addtocart">See Bundle</a>
            </div>
        `;

    } else {
        if(typeof sizes != "undefined"){
            qsHtml = `
            <div class="product__item-quickshop">            
              <div class="product__item-options">
                <div class="product__item-option size">
                  <span class="option-name">
                      size:
                  </span> 
                  <div class="option-labels">`;    
      
          let btnMessage = 'Add to Cart';
          let isDisabled = '';
          if(typeof firstAvailableVariant == 'undefined'){
            firstAvailableVariant = data.variants[0];
            btnMessage = 'Out of Stock';
            isDisabled = ' disabled';
          } 
      
          data.variants.forEach( v => {
            let selectedClass = (v.id == firstAvailableVariant.id) ? ' selected' : '';
            let disabledClass = v.available ? '' : ' disabled';
      
            qsHtml += 
                `<label title="${v.option2}" class="option${selectedClass}${disabledClass}" data-product-id="${data.id}" data-variant-id="${v.id}" data-available="${v.available}" onclick="qsSelectSize(this)">
                    <input type="radio" value="${v.option2}"> 
                    <span>${v.option2}</span>
                </label>`;
          });
          qsHtml += `</div></div></div>`;
      
          qsHtml += `
          
          <form action="/cart/add" method="post" enctype="multipart/form-data" class="product_form" onsubmit="return window.NAC.addToCart(this);">
            <input id="pid-${data.id}" class="id" name="id" value="${firstAvailableVariant.id}" hidden />
            <input type="number" id="Quantity" name="quantity" value="1" min="1" step="1" class="product_form_input product__qty-container" pattern="[0-9]*" hidden />
            <button type="submit" name="add" class="button btn btn-primary btn-wide product__btn-cta addtocart"${isDisabled}>${btnMessage}</button>
          </form>
          `;
          qsHtml += `</div>`;
          }
    }    
    itemHtml = itemHtml.replace(/{{itemOptions}}/g, qsHtml);

    // Add main attribute (Always put at the end of this function)
    itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
    itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
    itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
    itemHtml = itemHtml.replace(/{{itemUrl}}/g, this.buildProductItemUrl(data).replace('//', '/'));

    return itemHtml;
};

// function called by size labels to update variant
function qsSelectSize(e){
  const variantId = e.dataset.variantId;

  // add "selected" css class to indicate selected size  
  const optionArr = Array.from(e.parentNode.getElementsByClassName('option'));
  optionArr.forEach(el => {
    el.classList.remove('selected');
    if(el.dataset.variantId == variantId){
      el.classList.add('selected');
    }
  });

  // in or out of stock ATC button 
  const productCard = e.parentNode.parentNode.parentNode.parentNode; 
  const btn = productCard.getElementsByClassName('addtocart')[0];
  if(e.dataset.available == "true"){
    btn.disabled = false;
    btn.innerText = "Add to Cart";
  } else {
    btn.disabled = true;
    btn.innerText = "Out of Stock";
  }
  productCard.getElementsByClassName('id')[0].value = variantId;
}

// Build Product List Item
BCSfFilter.prototype.buildProductListItem = function(data) {
    // // Add Description
    // var itemDescription = jQ('<p>' + data.body_html + '</p>').text();
    // // Truncate by word
    // itemDescription = (itemDescription.split(" ")).length > 51 ? itemDescription.split(" ").splice(0, 51).join(" ") + '...' : itemDescription.split(" ").splice(0, 51).join(" ");
    // // Truncate by character
    // itemDescription = itemDescription.length > 350 ? itemDescription.substring(0, 350) + '...' : itemDescription.substring(0, 350);
    // itemHtml = itemHtml.replace(/{{itemDescription}}/g, itemDescription);
};

// Customize data to suit the data of Shopify API
BCSfFilter.prototype.prepareProductData = function(data) {
    for (var k in data) {
        // Featured image
        if (data['images_info'] > 0) {
            data[k]['featured_image'] = data['images_info'][0];
        } else {
            data[k]['featured_image'] = {width: '', height: '', aspect_ratio: 0}
        }

        // Add Options
        var optionsArr = [];
        for (var i in data[k]['options_with_values']) {
            optionsArr.push(data[k]['options_with_values'][i]['name']);
        }
        data[k]['options'] = optionsArr;

        // Customize variants
        for (var i in data[k]['variants']) {
            var variantOptionArr = [];
            var count = 1;
            var variant = data[k]['variants'][i];
            // Add Options
            var variantOptions = variant['merged_options'];
            if (Array.isArray(variantOptions)) {
                for (var j = 0; j < variantOptions.length; j++) {
                    var temp = variantOptions[j].split(':');
                    data[k]['variants'][i]['option' + (parseInt(j) + 1)] = temp[1];
                    data[k]['variants'][i]['option_' + temp[0]] = temp[1];
                    variantOptionArr.push(temp[1]);
                }
                data[k]['variants'][i]['options'] = variantOptionArr;
            }
            data[k]['variants'][i]['compare_at_price'] = parseFloat(data[k]['variants'][i]['compare_at_price']) * 100;
            data[k]['variants'][i]['price'] = parseFloat(data[k]['variants'][i]['price']) * 100;
        }

        // Add Description
        data[k]['description'] = data[k]['body_html'];
    }
    return data;
};

/************************** END BUILD PRODUCT LIST **************************/

// Build Pagination
BCSfFilter.prototype.buildPagination = function(totalProduct) {
    if (this.getSettingValue('general.paginationType') == 'default') {
        // Get page info
        var currentPage = parseInt(this.queryParams.page);
        var totalPage = Math.ceil(totalProduct / this.queryParams.limit);

        // If it has only one page, clear Pagination
        if (totalPage == 1) {
            jQ(this.selector.bottomPagination).html('');
            return false;
        }

        if (this.getSettingValue('general.paginationType') == 'default') {
            var paginationHtml = bcSfFilterTemplate.paginateHtml;

            // Build Previous
            var previousHtml = (currentPage > 1) ? bcSfFilterTemplate.previousActiveHtml : bcSfFilterTemplate.previousDisabledHtml;
            previousHtml = previousHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage - 1));
            paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);

            // Build Next
            var nextHtml = (currentPage < totalPage) ? bcSfFilterTemplate.nextActiveHtml :  bcSfFilterTemplate.nextDisabledHtml;
            nextHtml = nextHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage + 1));
            paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);

            // Create page items array
            var beforeCurrentPageArr = [];
            for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
                beforeCurrentPageArr.unshift(iBefore);
            }
            if (currentPage - 4 > 0) {
                beforeCurrentPageArr.unshift('...');
            }
            if (currentPage - 4 >= 0) {
                beforeCurrentPageArr.unshift(1);
            }
            beforeCurrentPageArr.push(currentPage);

            var afterCurrentPageArr = [];
            for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
                afterCurrentPageArr.push(iAfter);
            }
            if (currentPage + 3 < totalPage) {
                afterCurrentPageArr.push('...');
            }
            if (currentPage + 3 <= totalPage) {
                afterCurrentPageArr.push(totalPage);
            }

            // Build page items
            var pageItemsHtml = '';
            var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
            for (var iPage = 0; iPage < pageArr.length; iPage++) {
                if (pageArr[iPage] == '...') {
                    pageItemsHtml += bcSfFilterTemplate.pageItemRemainHtml;
                } else {
                    pageItemsHtml += (pageArr[iPage] == currentPage) ? bcSfFilterTemplate.pageItemSelectedHtml : bcSfFilterTemplate.pageItemHtml;
                }
                pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
                pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, pageArr[iPage]));
            }
            paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);

            jQ(this.selector.bottomPagination).html(paginationHtml);
        }
    }
};

/************************** BUILD TOOLBAR **************************/

// Build Sorting
BCSfFilter.prototype.buildFilterSorting = function() {
    if (bcSfFilterTemplate.hasOwnProperty('sortingHtml')) {
        jQ(this.selector.topSorting).html('');

        var sortingArr = this.getSortingList();
        if (sortingArr) {
            // Build content 
            var sortingItemsHtml = '';
            for (var k in sortingArr) {
                if (k !== 'created-descending' && k !== 'created-ascending' && k !== 'title-ascending' && k !== 'title-descending') {
                    sortingItemsHtml += '<option value="' + k +'">' + sortingArr[k] + '</option>';
                }
            }
            var html = bcSfFilterTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
            jQ(this.selector.topSorting).html(html);

            // Set current value
            jQ(this.selector.topSorting + ' select').val(this.queryParams.sort);
        }
    }
};

// Build Display type (List / Grid / Collage)
// BCSfFilter.prototype.buildFilterDisplayType = function() {
//     var itemHtml = '<a href="' + this.buildToolbarLink('display', 'list', 'grid') + '" title="Grid view" class="change-view bc-sf-filter-display-grid" data-view="grid"><span class="icon-fallback-text"><i class="fa fa-th" aria-hidden="true"></i><span class="fallback-text">Grid view</span></span></a>';
//     itemHtml += '<a href="' + this.buildToolbarLink('display', 'grid', 'list') + '" title="List view" class="change-view bc-sf-filter-display-list" data-view="list"><span class="icon-fallback-text"><i class="fa fa-list" aria-hidden="true"></i><span class="fallback-text">List view</span></span></a>';
//     jQ(this.selector.topDisplayType).html(itemHtml);

//     // Active current display type
//     jQ(this.selector.topDisplayType).find('.bc-sf-filter-display-list').removeClass('active');
//     jQ(this.selector.topDisplayType).find('.bc-sf-filter-display-grid').removeClass('active');
//     if (this.queryParams.display == 'list') {
//         jQ(this.selector.topDisplayType).find('.bc-sf-filter-display-list').addClass('active');
//     } else if (this.queryParams.display == 'grid') {
//         jQ(this.selector.topDisplayType).find('.bc-sf-filter-display-grid').addClass('active');
//     }
// };

/************************** END BUILD TOOLBAR **************************/

// Add additional feature for product list, used commonly in customizing product list
BCSfFilter.prototype.buildExtrasProductList = function(data, eventType) {};

// Build additional elements
BCSfFilter.prototype.buildAdditionalElements = function(data, eventType) {
    jQ('.collection__toolbar-count.collection__count').text(data.total_product + ' Items');

    [].forEach.call(document.querySelectorAll('div#bc-sf-filter-products > div'),function(_div){
        var params = {
            append_to_element:_div
            ,product_group_tag:_div.getAttribute('data-product_group_tag')
            ,callback_function: false
        };
        window.GPS.getGroupedProducts(params);
    });//foreach            
};